import { render, staticRenderFns } from "./Actualizar-precios.vue?vue&type=template&id=d5026e0a"
import script from "./Actualizar-precios.vue?vue&type=script&lang=js"
export * from "./Actualizar-precios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports